import React from "react";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";

import { SingleFeature } from "./SingleFeature";
import { ISingleFeature } from "./types";

type IProps = { features: ISingleFeature[] } & JSX.IntrinsicElements["div"];

export const FeaturesSection: React.FC<IProps> = ({ features }) => {
  const { bp } = useTheme();

  return (
    <Grid
      background="NAVY"
      customStyle={{
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          minHeight: 240,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        },
      }}
      id="FeaturesSection"
    >
      {features.map(feature => (
        <SingleFeature key={`SINGLE_FEATURE-${feature.title}`} {...feature} />
      ))}
    </Grid>
  );
};
